import Donator from "@/hosting/private/donator.js";
import Regular from "@/hosting/private/regular.js";

export default class PrivateHost {
  constructor(data, stream) {
    this.g = data;
    this.stream = stream;
    this.host = null;
  }
  begin() {
    let user = this.g.user;
    let donator = user.tier;
    if (donator && user.tier !== 'Friend') {
      this.host = new Donator(this.g, this.stream);
      this.host.init();
    } else {
      this.host = new Regular(this.g, this.stream);
      this.host.init();
    }
  }
  changeQuality(quality) {
    if (this.host) {
      this.host.changeQuality(quality);
    }
  }
  close(callback) {
    if (this.host) {
      this.host.close(callback);
    }
  }
}
